import { BButton, BCard } from '../../../../components/ui/generic';
import { Link, useParams } from 'react-router';
import { IconChevronLeft } from '@tabler/icons-react';
import Single from '../../../../components/Documents/Single';
import { useDocuments } from '../../../../hooks/Documents';
import { useHandleSubmitTunnel } from '../../../../hooks/useHandleSubmitTunnel';
import { useForm } from 'react-hook-form';

const Documents = () => {
  const { trainingId } = useParams();
  const { data } = useDocuments();
  const cv = data.find((d) => d.is_downloadabled === 3);
  const recto = data.find((d) => d.is_downloadabled === 1);
  const verso = data.find((d) => d.is_downloadabled === 2);

  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm();
  const onSubmit = useHandleSubmitTunnel('documents', trainingId);

  const canNext = !cv || !recto;
  return (
    <BCard maxSize={'md:max-w-2xl font-normal'}>
      <BCard.Header title={'Étape 3 : Documents'} withTitle />
      <BCard.Body>
        <Single type={'cv'} label={'CV*'} current={cv} />
        <Single type={'identityRecto'} label={'carte identité recto*'} current={recto} />
        <Single type={'identityVerso'} label={'carte identité verso'} current={verso} />

        <div className={'flex items-center justify-between'}>
          <div>
            <Link to={`/inscription/eligibilite/${trainingId}`} className={'hover:text-primary-700 flex items-center'}>
              <IconChevronLeft className={'size-5'} /> <p className={'text-sm'}>Retour</p>
            </Link>
          </div>
          <form id={'tunnelFormStep2'} onSubmit={handleSubmit(onSubmit)}>
            <input hidden defaultValue={'next'} {...register('submit')} />
            <BButton
              type={'submit'}
              size={'md'}
              label={'Suivant'}
              isDisabled={canNext || isSubmitting}
              isProcessing={isSubmitting}
            />
          </form>
        </div>
      </BCard.Body>
    </BCard>
  );
};

export default Documents;
